import { useTranslation } from "react-i18next";
import { useCallback, useEffect, useState } from "react";

import { Col, OverlayTrigger, Row, Tooltip } from "react-bootstrap";
import { CardBody, CustomCard, CardTitle, LimitCharacterDiv } from "./styles";

import handleLongText from "../../utils/handleLongText/handleLongText";
import { ICardList } from "../../models/ICardList";
import { useHistory } from "react-router-dom";

import { colors } from "../../../theme/theme";
import { TypeCourse } from "../translate-type-course";

export const CardCourse: React.FC<ICardList> = ({
	material,
	isMaterialView,
	isNew = false,
	children,
	onDetails,
}) => {
	const { t: translation } = useTranslation();
	const [color, setColor] = useState<string>("black");
	const history = useHistory();

	useEffect(() => {
		setColor(colors.mainColors.indigo);
	}, [material.type_product, material?.modalities, translation]);

	const handleCardDetails = useCallback((e: any) => {
		if (onDetails) {
			onDetails({ material, tab: e.button });
		}
	}, []);

	return (
		<>
			<CustomCard style={{ borderLeft: 10 + `px solid ${color}` }}>
				<CardBody>
					<Row>
						<Col xs={12} onMouseDown={(e) => handleCardDetails(e)}>
							<Row>
								<Col lg={6}>
									<CardTitle>
										<h6>
											<OverlayTrigger placement="top" overlay={<Tooltip>{material.name}</Tooltip>}>
												<span>{handleLongText(material.name, 57)}</span>
											</OverlayTrigger>
                                    	</h6>
									</CardTitle>
									<LimitCharacterDiv>
										<b>
											{translation(
												"components.card-news.Workload"
											)}
											:{" "}
										</b>
										{!!material?.workload
											? material.workload + "h"
											: translation(
													"userAccount.uninformed"
											  )}
									</LimitCharacterDiv>
								</Col>

								<Col lg={6}>
									<LimitCharacterDiv className="mb-2">
										<b>Qtd de disciplinas:</b>{" "}
										{material.disciplines_count}
									</LimitCharacterDiv>
									<LimitCharacterDiv>
										<b>Modalidade:</b>{" "}
										<TypeCourse
											type={material.type_course!}
										/>
									</LimitCharacterDiv>
								</Col>
							</Row>
						</Col>
					</Row>
				</CardBody>
			</CustomCard>
		</>
	);
};
